export default "__VITE_ASSET__BckioUK6__"